export default __webpack_public_path__ + "static/g1one-82f02bba2031533112e56383b035542e.jpg";